const middleware = {}

middleware['auth'] = require('../src/middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['expect-ct'] = require('../src/middleware/expect-ct.js')
middleware['expect-ct'] = middleware['expect-ct'].default || middleware['expect-ct']

export default middleware
